// extracted by mini-css-extract-plugin
export default {"item":"DocumItem_item__FJIUN","type":"DocumItem_type__bBGoW","name":"DocumItem_name__cE5Ot","documents":"DocumItem_documents__FL6rm"};